// extracted by mini-css-extract-plugin
module.exports = {"divprofile":"Contacto_divprofile__1rgyQ","imgradio":"Contacto_imgradio__AZFfY"};